import React from 'react';
import PropTypes from 'prop-types';

import { METRICS_COMPONENT_TYPE } from 'configs/dashboardMetrices';
import OptionList from './OptionList';

const { NUMBER } = METRICS_COMPONENT_TYPE;

const ValueMetrics = ({ configValue, handleConfigDataChange }) => {
  const { name: metricName, items } = NUMBER.configOptions.values;
  const itemsList = items.map(({ name, title, options }) => (
    <OptionList
      key={name}
      handleConfigDataChange={handleConfigDataChange}
      metricName={metricName}
      name={name}
      title={title}
      options={options}
      value={configValue}
    />
  ));

  return (
    <div>
      <div>
        View the total or average value for this metrics
      </div>
      <hr />
      <div>
        {itemsList}
      </div>
    </div>
  )
};

ValueMetrics.propTypes = {
  configValue: PropTypes.object.isRequired,
  handleConfigDataChange: PropTypes.func.isRequired
};

export default ValueMetrics;



// WEBPACK FOOTER //
// ./src/components/dashboard/metrics-list/ValueMetrics.js